import GridContainer from "@/components/common/GridContainer"
import { getMapKey } from "@/utils/utils"
import Tile from "@/components/TilesModule/variants/TilesBlockHeaderDescriptionIrregular/Tile"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

export default function TilesBlockHeaderDescriptionIrregular({ data, paddings, headerDescription }) {
	const id = data?.id || ""
	const rows = data?.rows || []

	return (
		<section id={id} className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			{rows.map((row, index) => {
				const tiles = row?.tiles || []
				return (
					<GridContainer key={getMapKey(row, index)}>
						{tiles.map((tile, index) => (
							<Tile key={getMapKey(tile, index)} item={tile} />
						))}
					</GridContainer>
				)
			})}
		</section>
	)
}
